import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import useDocumentTitle from '../hooks/useDocumentTitle'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'




const TeamInvitationErrorNotFound = (props) => {
  const {isMassInvite} = props
  useDocumentTitle(`Token not found | Team Invitation`, 'Team Invitation')
  const tip = isMassInvite
    ? 'Try requesting another link.'
    : 'Try copying the link from your email again.'
  return (
    _jsxs(InviteDialog, { children: [
      _jsx(DialogTitle, { children: "Invalid Invitation" })
      , _jsxs(DialogContent, { children: [
        _jsx(InvitationDialogCopy, { children: "The invitation token is not valid."     })
        , _jsx(InvitationDialogCopy, { children: tip})
      ]})
    ]})
  )
}

export default TeamInvitationErrorNotFound
